import React, { useState, useEffect } from "react";
import DataTable from "../components/DataTable.js";
import { fetchDataFromAPI, saveData, deleteData } from "../components/api.js";
import subscriptionStatus from "../components/SubscriptionStatus.js";
// import FileUploaderCell from "../../src/components/FileUploaderCell";
const getRangeInputProps = (col) => {
  if (col.type === "range") {
    return { min: 0, max: 5, step: 0.5 }; // Limit range inputs to 0-5 with step of 0.1
  }
  return {}; // Return empty object for non-range types
};

const Products = () => {
  const [products, setProducts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState("created_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [error, setError] = useState(null);
  const isSubscribed = subscriptionStatus();
  const [materialsOptions, setMaterialsOptions] = useState([]);
  const [earningsOptions, setEarningsOptions] = useState([]);
  const [ordersOptions, setOrdersOptions] = useState([]);
  const [categoriesOptions, setCategoriesOptions] = useState([]);
  useEffect(() => {
    fetchData();
    console.log("referching data", currentPage, filters, sortField, sortOrder);
  }, [filters, sortField, sortOrder]);

  const fetchData = async (page = 1, itemsPerPage = 10, filters) => {
    try {
      const token = localStorage.getItem("token");
      const filterParamsObj = {
        page,
        limit: 10,
        ...filters,
        includeDeleted: "false",
      };
      // Add sortField and sortOrder only if they are not empty
      if (sortField) {
        filterParamsObj.sortField = sortField;
      }
      if (sortOrder) {
        filterParamsObj.sortOrder = sortOrder;
      }
      console.log("Filter Params:", new URLSearchParams(filterParamsObj));

      const filterParams = new URLSearchParams(filterParamsObj).toString();
      console.log("Filter Params:", filterParams);
      // Fetch products with filters, sorting, and pagination
      const { data: products, pagination } = await fetchDataFromAPI(
        `/api/products`,
        filterParams,
        token
      );
      const { data: materials } = await fetchDataFromAPI(
        `/api/materials`,
        {},
        token
      );
      const { data: earnings } = await fetchDataFromAPI(
        `/api/earnings`,
        {},
        token
      );
      const { data: categories } = await fetchDataFromAPI(
        `/api/categories`,
        {},
        token
      );
      const { data: orders } = await fetchDataFromAPI(`/api/orders`, {}, token);
      setProducts(products || []);
      setMaterialsOptions(materials || []);
      setEarningsOptions(earnings || []);
      setOrdersOptions(orders || []);
      setCategoriesOptions(categories || []);
      setTotalPages(pagination?.totalPages || 1);
      console.log("Materials:", materials);
      console.log("products:", products);
      console.log("earnings:", earnings);
      console.log("orders:", orders);
      console.log("categories:", categories);
    } catch (err) {
      console.error("Error fetching data:", err.message);
      setError(err.message);
    }
  };

  const handleAddRow = async () => {
    try {
      const newRow = {
        name: "New Product",
        quantity_in_stock: "",
        selling_price: "",
        cost_of_material: "",
        cost_of_packaging: "",
        profit_margin: "",
        sku: "",
        tax_rate: "",
        discount: "",
        earnings_public_id: "",
        materials: "",
        order_public_id: "",
        warehouse_location: "",
        category: "",
      };
      await saveData("/api/products", newRow, "POST");
      fetchData();
    } catch (err) {
      console.error("Error adding product:", err);
    }
  };

  const handleEdit = async (id, updatedData) => {
    try {
      console.log("updatedData", updatedData);
      const updatedProduct = {
        ...updatedData,
        category:
          categoriesOptions.find(
            (category) => category.name === updatedData.category
          )?.id || null, // Convert category name to category_id
      };
      console.log("updatedProduct", updatedProduct);

      await saveData(`/api/products/${id}`, updatedProduct);
      fetchData();
    } catch (err) {
      console.error("Error editing product:", err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteData(`/api/products/${id}`);
      fetchData();
    } catch (err) {
      console.error("Error deleting product:", err);
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchData();
  };

  const handleSort = (field, order) => {
    setSortField(field);
    setSortOrder(order);
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    fetchData();
  };

  const valueStyles = {
    "in-progress": {
      backgroundColor: "orange", // Blue for in-progress
      color: "white",
    },
    completed: {
      backgroundColor: "green", // Green for completed
      color: "white",
    },
    pending: {
      backgroundColor: "yellow", // Orange for pending
      color: "white",
    },
    // Add any additional styles as needed
  };
  const columns = [
    {
      header: "Photo",
      accessor: "photo",
      type: "file",
    },

    { header: "Name", accessor: "name" },
    { header: "Description", accessor: "description" },

    { header: "Quantity in Stock", accessor: "quantity_in_stock" },
    { header: "Selling Price", accessor: "selling_price" },
    { header: "Cost of Material", accessor: "cost_of_material" },
    { header: "Cost of Packaging", accessor: "cost_of_packaging" },
    {
      header: "Materials",
      accessor: "materials",
      type: "list",
      options: materialsOptions,
    },
    {
      header: "Earnings",
      accessor: "earnings_public_id", // Custom rendering for combined names and dates
      type: "TextDetails",
    },
    {
      header: "Orders",
      accessor: "order_public_id", // Custom rendering for combined names and dates
      type: "TextDetails",
    },
    { header: "Profit Margin", accessor: "profit_margin", type: "showOnly" },
    { header: "Number sold", accessor: "number_sold" },
    {
      header: "Status",
      accessor: "status",
      type: "dropdown",
      options: [
        { value: "inactive", label: "inactive" },
        { value: "active", label: "active " },
      ],
      valueStyles,
    },
    { header: "SKU", accessor: "sku" },
    { header: "Tax Rate", accessor: "tax_rate" },
    { header: "Discount", accessor: "discount" },
    { header: "Warehouse Location", accessor: "warehouse_location" },
    {
      header: "Category",
      accessor: "category",
      type: "dropdown",
      options: categoriesOptions.map((category) => ({
        value: category.id,
        label: category.name,
      })),
      valueStyles,
    },
  ];

  return (
    <DataTable
      title="Products"
      columns={columns}
      data={products}
      currentPage={currentPage}
      totalPages={totalPages}
      onSort={handleSort}
      sortField={sortField}
      sortOrder={sortOrder}
      setData={setProducts}
      onPageChange={handlePageChange}
      filters={filters}
      onFilterChange={handleFilterChange}
      onAddRow={handleAddRow}
      actions={[
        {
          label: "Edit",
          onClick: (row) => {
            const updatedData = { ...row, name: "Updated Name" };
            handleEdit(row.id, updatedData);
          },
        },
        {
          label: "Delete",
          onClick: (row) => handleDelete(row.id),
        },
      ]}
      apiEndpoint="/api/products"
      itemsPerPage={10}
      fetchData={fetchData}
      getRangeInputProps={getRangeInputProps}
    />
  );
};

export default Products;
